export const STORAGE_KEY = 'tzlvt_promo_stats';
export const SETTINGS = {
  maxDailyViews: 2,
  maxTotalViews: 6,
};
